/** Created by azhou on 2019/4/1.*/
<template>
  <ul class="list-item">
    <li class="w-50 list-item-col">{{Itemize.company}}</li>
    <li class="w-50 list-item-col">{{Itemize.date_in | formatTimestamp}}</li>
    <li class="w-50 list-item-col" v-if="!brand">{{Itemize.num}} 人</li>
    <li class="w-50 list-item-col" v-if="!brand">{{Itemize.order_type | formatVar('OrderType')}}</li>
    <li class="w-50 list-item-col">{{Itemize.time | formatTimestamp(1)}}</li>
    <li class="w-50 list-item-col" v-if="brand" >{{Itemize.status | formatVar('BOrderStatus')}}</li>
    <li class="w-50 list-item-col" v-else>{{Itemize.status | formatVar('SOrderStatus')}}</li>
  </ul>
</template>

<script>
  import {mapGetters} from 'vuex'
  export default {
    name: 'ItemizeScenic',
    props:{
      Itemize:{}
    },
    computed: {
      ...mapGetters(['brand'])
    }
  }
</script>
